import { createFileRoute } from '@tanstack/react-router'
import AllInOneService from '@/components/b2c_student/AllInOneService'
import { guardStudentOrB2CClient } from '@/lib/auth/routeGuards'

export const Route = createFileRoute('/student/all-in-one')({
  beforeLoad: guardStudentOrB2CClient,
  component: AllInOnePage,
})

function AllInOnePage() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <AllInOneService />
    </div>
  )
}
